import { useTranslation } from 'react-i18next'
import trackEvent from '../../utils/trackEvent'
import { getCtaContent } from '../../content/ctaContent'

/*
 * The site's one closing move, used at the end of every content page:
 * open a card on the board (primary) or book a time (fast lane). The lane
 * prop carries the page's context into /talk as the lead source.
 */
const CtaClose = ({ lane = 'discovery', page = 'page' }) => {
  const { i18n } = useTranslation()
  const c = getCtaContent(i18n.language).close

  return (
    <section className="px-6 pb-24 md:px-16">
      <div className="mx-auto max-w-6xl border-t border-white/[0.08] pt-14 text-center">
        <p className="text-xs uppercase tracking-[0.4em] text-slate-400">{c.kicker}</p>
        <h2 className="mx-auto mt-4 max-w-2xl text-3xl font-light leading-tight md:text-4xl">{c.title}</h2>
        <p className="mx-auto mt-4 max-w-xl leading-7 text-slate-400">{c.body}</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <a
            href={`/talk?i=${lane}`}
            onClick={() => trackEvent('cta_close_talk', { page, lane })}
            className="btn-board btn-board-orange"
          >
            {c.talk}
            <span aria-hidden="true">&#8594;</span>
          </a>
          <a
            href="/book"
            onClick={() => trackEvent('cta_close_book', { page })}
            className="btn-board btn-board-cyan"
          >
            {c.book}
            <span aria-hidden="true">&#8594;</span>
          </a>
        </div>
      </div>
    </section>
  )
}

export default CtaClose
